// extracted by mini-css-extract-plugin
module.exports = {"boxImage":"_3zGBahgueNmKC2GwPMXqb2","link":"_2CVHNNCnsSan4rF0M9PELV"};